import { find } from "lodash";
import React, { useCallback, useMemo, useState } from "react";
import { generateUUID } from "utils/uuid";

import ACModalRenderer, {
  ModalConfig,
} from "ac-components/ac-modal-renderer/ACModalRenderer";

export default function useModalRenderer() {
  const [configs, setConfigs] = useState<ModalConfig[]>([]);
  const show = useCallback((config: ModalConfig) => {
    setConfigs((prevConfigs) => {
      const id = config.id || generateUUID();
      if (config.id && prevConfigs.some((c) => c.id === config.id)) {
        return prevConfigs;
      }
      return [...prevConfigs, { ...config, id }];
    });
  }, []);
  return useMemo(
    () => ({
      context: (
        <ACModalRenderer
          configs={configs}
          onClose={(id, state) => {
            setConfigs((prevConfigs) => {
              const currentConfig = find(prevConfigs, { id });
              if (currentConfig && currentConfig.onClose) {
                currentConfig.onClose(state);
              }
              return prevConfigs.filter((c) => c.id !== id);
            });
          }}
        />
      ),
      show,
    }),
    [configs, show],
  );
}
